import { stores } from '../translations';

export const BLACK_FRIDAY = 'blackFriday2025';
export const NEW_YEAR = 'newYear2025';
export const ACHIEVEMENTS = 'achievements2025';
export const PROMO_PHL = 'promo_phl';
export const JANUARY_BONUS = 'january_bonus';
export const NEW_SEASON_MODAL = 'new_season_modal';
export const TEENS_BOT = 'teens_bot';
export const TEENS_TELEGRAM = 'teens_telegram';
export const ESTEE_LAUDER = 'estee_lauder';
export const RAMADAN = 'ramadan';

export const events = [
  BLACK_FRIDAY,
  NEW_YEAR,
  ACHIEVEMENTS,
  PROMO_PHL,
  JANUARY_BONUS,
  TEENS_BOT,
  TEENS_TELEGRAM,
  NEW_SEASON_MODAL,
  ESTEE_LAUDER,
  RAMADAN,
];

export const availableData = {
  [BLACK_FRIDAY]: {
    [stores.ru]: false,
    [stores.kz]: false,
    [stores.ae]: false,
  },
  [ACHIEVEMENTS]: {
    [stores.ru]: true,
    [stores.kz]: true,
    [stores.ae]: true,
  },
  [NEW_YEAR]: {
    [stores.ru]: true,
    [stores.kz]: true,
    [stores.ae]: false,
  },
  [PROMO_PHL]: {
    [stores.ru]: true,
    [stores.kz]: false,
    [stores.ae]: false,
  },
  [JANUARY_BONUS]: {
    [stores.ru]: true,
    [stores.kz]: true,
    [stores.ae]: true,
  },
  [TEENS_BOT]: {
    [stores.ru]: true,
    [stores.kz]: false,
    [stores.ae]: false,
  },
  [TEENS_TELEGRAM]: {
    [stores.ru]: true,
    [stores.kz]: false,
    [stores.ae]: false,
  },
  [NEW_SEASON_MODAL]: {
    [stores.ru]: true,
    [stores.kz]: true,
    [stores.ae]: true,
  },
  [ESTEE_LAUDER]: {
    [stores.ru]: true,
    [stores.kz]: false,
    [stores.ae]: false,
  },
  [RAMADAN]: {
    [stores.ru]: false,
    [stores.kz]: false,
    [stores.ae]: true,
  },
};

export default function getAvailableEvents(store) {
  return events.filter((event) => availableData[event][store]);
}

export function getIsAvailableEvent(store, event) {
  return getAvailableEvents(store).includes(event);
}
